<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>


<script>
export default {
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    //提供
    return {
      reload: this.reload
    };
  },
  created() {
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
    window.onbeforeunload = function() {
      var storage = window.localStorage;
      storage.clear();
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
*{ margin:0px; padding:0px;}
body,html {
  padding: 0;
  margin:0;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #e18c3a !important;
}
</style>
